"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7629],{

/***/ 51991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useDeclinedOrderDiscountVoucher; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93633);
/* harmony import */ var _the_volte_svc_core_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44859);
/* harmony import */ var _the_volte_svc_core_sdk__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_the_volte_svc_core_sdk__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22841);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _app_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42660);
/* harmony import */ var _hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83319);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetOrderByDeclinedVoucher($declinedOrderVoucherCode: String) {\n    order(declinedOrderVoucherCode: $declinedOrderVoucherCode) {\n      id\n      declinedOrderVoucher {\n        id\n        code\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var SEARCH_ROUTE = "/search";
var GET_ORDER_BY_DECLINED_VOUCHER = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_6__["default"])(_templateObject());
var useDeclinedOrderDiscountVoucher = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), voucherValid = ref[0], setVoucherValid = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_hooks_useLocalStorage__WEBPACK_IMPORTED_MODULE_5__/* .useLocalStorage */ ._)("declinedOrderVoucher", undefined), 2), declinedOrderVoucher = ref1[0], setDeclinedOrderVoucher = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var asPath = router.asPath, pathname = router.pathname;
    var user = (0,_the_volte_svc_core_sdk__WEBPACK_IMPORTED_MODULE_1__.useAuth)().user;
    var declinedVoucherCodeParam = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var url = new URL("".concat(_app_constants__WEBPACK_IMPORTED_MODULE_4__/* .siteUrl */ .or, "/").concat(asPath));
        return url.searchParams.get("declinedVoucherCode");
    }, []);
    var ref2 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useQuery */ .a)(GET_ORDER_BY_DECLINED_VOUCHER, {
        variables: {
            declinedOrderVoucherCode: declinedOrderVoucher
        },
        fetchPolicy: "no-cache",
        skip: !declinedOrderVoucher || !user,
        onCompleted: function() {
            setVoucherValid(true);
            var url = new URL(window.location.href);
            var declinedVoucherCode = url.searchParams.get("declinedVoucherCode");
            if (!declinedVoucherCode) return;
            url.searchParams.delete("declinedVoucherCode");
            router.replace(url.toString(), undefined, {
                shallow: true
            });
        }
    }), orderLoading = ref2.loading;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (declinedVoucherCodeParam && pathname === SEARCH_ROUTE) {
            setDeclinedOrderVoucher(declinedVoucherCodeParam);
        }
    }, [
        declinedVoucherCodeParam,
        pathname
    ]);
    return {
        declinedOrderVoucher: declinedOrderVoucher,
        declinedVoucherCodeParam: declinedVoucherCodeParam,
        orderLoading: orderLoading,
        voucherValid: voucherValid
    };
};


/***/ }),

/***/ 27698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var use_query_params__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97947);
/* harmony import */ var _app_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);
/* harmony import */ var _utils_collections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34102);
/* harmony import */ var _utils_filters__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97126);









var useProductFiltering = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, presetAttributeFilter = ref.presetAttributeFilter, presetPriceFilters = ref.presetPriceFilters, presetLocationFilter = ref.presetLocationFilter, presetDeliveryFilter = ref.presetDeliveryFilter, categoryFilter = ref.categoryFilter;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,use_query_params__WEBPACK_IMPORTED_MODULE_2__/* .useQueryParam */ .Wd)("sortBy", use_query_params__WEBPACK_IMPORTED_MODULE_2__/* .StringParam */ .Zp), 2), sort = ref1[0], setSort = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,use_query_params__WEBPACK_IMPORTED_MODULE_2__/* .useQueryParam */ .Wd)("filters", _utils_collections__WEBPACK_IMPORTED_MODULE_4__/* .FilterQuerySet */ .M), 2), queryParams = ref2[0], setQueryParams = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,use_query_params__WEBPACK_IMPORTED_MODULE_2__/* .useQueryParam */ .Wd)("keyword", use_query_params__WEBPACK_IMPORTED_MODULE_2__/* .StringParam */ .Zp), 2), keyword = ref3[0], setKeyword = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), clientFiltered = ref4[0], setClientFiltered = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((presetPriceFilters === null || presetPriceFilters === void 0 ? void 0 : presetPriceFilters.gte) || (presetPriceFilters === null || presetPriceFilters === void 0 ? void 0 : presetPriceFilters.lte) ? [
        presetPriceFilters
    ] : (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .getPricesFilter */ .ze)(queryParams)), pricesFilter = ref5[0], setPricesFilter = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((presetLocationFilter === null || presetLocationFilter === void 0 ? void 0 : presetLocationFilter.length) ? presetLocationFilter : (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .getLocationFilter */ .Xk)(queryParams)), locationFilter = ref6[0], setLocationFilter = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(presetDeliveryFilter || (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .getDeliveryFilter */ .od)(queryParams)), deliveryFilter = ref7[0], setDeliveryFilter = ref7[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        if (!(presetLocationFilter === null || presetLocationFilter === void 0 ? void 0 : presetLocationFilter.length) && JSON.stringify(locationFilter) !== JSON.stringify((0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .getLocationFilter */ .Xk)(queryParams))) {
            setLocationFilter((0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .getLocationFilter */ .Xk)(queryParams));
        }
        if (!presetPriceFilters && JSON.stringify(pricesFilter) !== JSON.stringify((0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .getPricesFilter */ .ze)(queryParams))) {
            setPricesFilter((0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .getPricesFilter */ .ze)(queryParams));
        }
        if ((queryParams === null || queryParams === void 0 ? void 0 : (ref = queryParams.prices) === null || ref === void 0 ? void 0 : ref.length) === 0) {
            var updatedParams = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, queryParams);
            delete updatedParams.prices;
            setQueryParams(updatedParams);
        }
    }, [
        presetLocationFilter,
        presetPriceFilters
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (clientFiltered) {
            setClientFiltered(false);
        }
    }, [
        clientFiltered
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setClientFiltered(true);
    }, [
        deliveryFilter
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (clientFiltered) setQueryParams(function(prev) {
            var updatedParams = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, prev);
            if (deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.postCode) {
                updatedParams["post-code"] = [
                    deliveryFilter.postCode
                ];
            } else {
                delete updatedParams["post-code"];
            }
            if (deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.date) {
                updatedParams.date = [
                    deliveryFilter.date
                ];
            } else {
                delete updatedParams.date;
            }
            return updatedParams;
        });
    }, [
        deliveryFilter
    ]);
    var filters = (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .getFilters */ .Zj)(_app_constants__WEBPACK_IMPORTED_MODULE_3__/* .productsPerPage */ .ct, pricesFilter, locationFilter, queryParams, sort, deliveryFilter || null, keyword);
    if (presetAttributeFilter) {
        filters.attributes = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, filters.attributes, presetAttributeFilter);
    }
    if (categoryFilter) {
        filters.categorySlugs = categoryFilter.category;
    }
    var handleClearFilters = function() {
        return setQueryParams({});
    };
    var handleFiltersChange = function(name, value, singleValue) {
        setClientFiltered(true);
        (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .filtersChangeHandler */ .pq)({
            attributes: queryParams
        }, queryParams, setQueryParams)(name, value, singleValue);
    };
    var handlePricesFilter = function(pricesFilterValue) {
        setClientFiltered(true);
        var priceSlugs = pricesFilterValue.map(function(filter) {
            return filter.slug || "";
        });
        (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .filtersChangeHandler */ .pq)({
            attributes: queryParams
        }, queryParams, setQueryParams)("prices", priceSlugs.join("_"), true);
        setPricesFilter(pricesFilterValue);
    };
    var handleLocationFilter = function(locationFilterValue) {
        setClientFiltered(true);
        (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .filtersChangeHandler */ .pq)({
            attributes: queryParams
        }, queryParams, setQueryParams)("location", String(locationFilterValue.slug));
        var newLocationFilter = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(locationFilter);
        var existingIndex = newLocationFilter.indexOf(locationFilterValue);
        if (existingIndex > -1) {
            newLocationFilter.splice(existingIndex);
        } else {
            newLocationFilter.push(locationFilterValue);
        }
        setLocationFilter(newLocationFilter);
    };
    var handleDeliveryFilter = function(deliveryFilterValue) {
        setClientFiltered(true);
        var postCode = deliveryFilterValue.postCode, date = deliveryFilterValue.date;
        if (postCode) {
            (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .filtersChangeHandler */ .pq)({
                attributes: queryParams
            }, queryParams, setQueryParams)("post-code", postCode, true);
        }
        if (date) {
            (0,_utils_filters__WEBPACK_IMPORTED_MODULE_5__/* .filtersChangeHandler */ .pq)({
                attributes: queryParams
            }, queryParams, setQueryParams)("date", date, true);
        }
        setDeliveryFilter(deliveryFilterValue);
    };
    var handleOrderChange = function(value) {
        var searchParams = new URLSearchParams(window.location.search);
        if (value === null || value === void 0 ? void 0 : value.value) {
            searchParams.set("sortBy", value.value);
        } else {
            searchParams.delete("sortBy");
        }
        if (!searchParams.has("filters")) {
            searchParams.set("filters", "rental-period_4-days");
        }
        router.replace({
            pathname: router.pathname,
            search: searchParams.toString()
        }, undefined, {
            shallow: true
        });
        setSort((value === null || value === void 0 ? void 0 : value.value) || null);
    };
    var hasAttributeFilter = Object.keys((filters === null || filters === void 0 ? void 0 : filters.attributes) || {}).length > 0;
    var hasDeliveryFilter = !(deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.date) && !(deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.postCode);
    var hasPriceFilter = pricesFilter;
    var isFiltered = hasAttributeFilter || hasDeliveryFilter || hasPriceFilter;
    return {
        clientFiltered: clientFiltered,
        filters: filters,
        pricesFilter: pricesFilter,
        locationFilter: locationFilter,
        deliveryFilter: deliveryFilter,
        hasDeliveryFilter: hasDeliveryFilter,
        handleClearFilters: handleClearFilters,
        handleFiltersChange: handleFiltersChange,
        handlePricesFilter: handlePricesFilter,
        handleLocationFilter: handleLocationFilter,
        handleDeliveryFilter: handleDeliveryFilter,
        setDeliveryFilter: setDeliveryFilter,
        isFiltered: isFiltered,
        handleOrderChange: handleOrderChange,
        keyword: keyword,
        setKeyword: setKeyword
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useProductFiltering);


/***/ }),

/***/ 34102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ FilterQuerySet; },
/* harmony export */   "a": function() { return /* binding */ SORT_OPTIONS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _react_intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47355);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _temp_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72110);





var SORT_OPTIONS = [
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsClear */ .hA.sortOptionsClear)),
        value: null
    },
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsPrice */ .hA.sortOptionsPrice)),
        value: "price"
    },
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsPriceDsc */ .hA.sortOptionsPriceDsc)),
        value: "-price"
    },
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsCreatedAt */ .hA.sortOptionsCreatedAt)),
        value: "created_at"
    },
    {
        label: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_react_intl__WEBPACK_IMPORTED_MODULE_0__/* .FormattedMessage */ ._H, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _temp_intl__WEBPACK_IMPORTED_MODULE_2__/* .prodListHeaderCommonMsg.sortOptionsCreatedAtDsc */ .hA.sortOptionsCreatedAtDsc)),
        value: "-created_at"
    }, 
];
var FilterQuerySet = {
    encode: function encode(valueObj) {
        var str = [];
        Object.keys(valueObj).forEach(function(value) {
            str.push("".concat(value, "_").concat(valueObj[value].join("_")));
        });
        return str.join(".");
    },
    decode: function decode(strValue) {
        var obj = {};
        var propsWithValues = (strValue || "").split(".").filter(function(n) {
            return n;
        });
        propsWithValues.map(function(value) {
            var propWithValues = value.split("_").filter(function(n) {
                return n;
            });
            obj[propWithValues[0]] = propWithValues.slice(1);
        });
        return obj;
    }
};


/***/ }),

/***/ 59686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FX": function() { return /* binding */ priceFilterOptions; },
/* harmony export */   "Ob": function() { return /* binding */ locationFilterOptions; },
/* harmony export */   "j_": function() { return /* binding */ priceFilterValues; },
/* harmony export */   "qV": function() { return /* binding */ locationFilterValues; }
/* harmony export */ });
var priceFilterOptions = [
    {
        name: "Under $100",
        slug: "under-100"
    },
    {
        name: "$100 - $150",
        slug: "100-150"
    },
    {
        name: "$150 - $200",
        slug: "150-200"
    },
    {
        name: "$200 - $250",
        slug: "200-250"
    },
    {
        name: "Over $250",
        slug: "over-250"
    }, 
];
var priceFilterValues = {
    "under-100": {
        gte: 0,
        lte: 99.99,
        slug: "under-100"
    },
    "100-150": {
        gte: 100,
        lte: 150,
        slug: "100-150"
    },
    "150-200": {
        gte: 150,
        lte: 200,
        slug: "150-200"
    },
    "200-250": {
        gte: 200,
        lte: 250,
        slug: "200-250"
    },
    "over-250": {
        gte: 250.99,
        lte: null,
        slug: "over-250"
    }
};
var locationFilterValues = {
    adelaide: {
        gte: 5000,
        lte: 5799,
        slug: "adelaide",
        name: "Adelaide"
    },
    brisbane: {
        gte: 4000,
        lte: 4999,
        slug: "brisbane",
        name: "Brisbane"
    },
    canberra: {
        gte: 2600,
        lte: 2618,
        slug: "canberra",
        name: "Canberra"
    },
    darwin: {
        gte: 800,
        lte: 899,
        slug: "darwin",
        name: "Darwin"
    },
    hobart: {
        gte: 7000,
        lte: 7789,
        slug: "hobart",
        name: "Hobart"
    },
    melbourne: {
        gte: 3000,
        lte: 3999,
        slug: "melbourne",
        name: "Melbourne"
    },
    perth: {
        gte: 6000,
        lte: 6797,
        slug: "perth",
        name: "Perth"
    },
    sydney: {
        gte: 2000,
        lte: 2599,
        slug: "sydney",
        name: "Sydney"
    }
};
var locationFilterOptions = Object.keys(locationFilterValues).map(function(key) {
    return {
        name: locationFilterValues[key].name,
        slug: locationFilterValues[key].slug,
        lte: locationFilterValues[key].lte,
        gte: locationFilterValues[key].gte
    };
});


/***/ }),

/***/ 97126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ getActiveFilterAttributes; },
/* harmony export */   "Xk": function() { return /* binding */ getLocationFilter; },
/* harmony export */   "YA": function() { return /* binding */ getBrowserPath; },
/* harmony export */   "Zj": function() { return /* binding */ getFilters; },
/* harmony export */   "od": function() { return /* binding */ getDeliveryFilter; },
/* harmony export */   "pq": function() { return /* binding */ filtersChangeHandler; },
/* harmony export */   "ze": function() { return /* binding */ getPricesFilter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _filterData__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59686);






/*
 * Functions used for initial state
 */ var getBrowserParams = function() {
    return new URLSearchParams(window.location.search).toString();
};
var getBrowserPath = function(router) {
    return [
        router.asPath.split("?")[0],
        getBrowserParams()
    ].join("?");
};
var getAttributesFromQueryParams = function(queryParams) {
    var prices = queryParams.prices, location = queryParams.location, lenderRating = queryParams.lenderRating, postCode = queryParams["post-code"], date = queryParams.date, attributes = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(queryParams, [
        "prices",
        "location",
        "lenderRating",
        "post-code",
        "date"
    ]);
    return attributes;
};
var getFilters = function(pageSize, pricesFilter, locationFilter, queryParams, sort, deliveryFilter, keyword) {
    return {
        attributes: getAttributesFromQueryParams(queryParams),
        pageSize: pageSize,
        lenderRating: queryParams === null || queryParams === void 0 ? void 0 : queryParams.lenderRating,
        prices: pricesFilter,
        postcodes: locationFilter.map(function(lf) {
            return {
                gte: lf.gte,
                lte: lf.lte
            };
        }),
        sortBy: sort || null,
        availableDeliveryDate: (deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.date) || undefined,
        availableDeliveryPostcode: (deliveryFilter === null || deliveryFilter === void 0 ? void 0 : deliveryFilter.postCode) || undefined,
        search: keyword || undefined
    };
};
var getPricesFilter = function(queryParams) {
    var prices = ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.prices) || []).filter(function(slug) {
        return slug in _filterData__WEBPACK_IMPORTED_MODULE_0__/* .priceFilterValues */ .j_;
    }).map(function(slug) {
        return _filterData__WEBPACK_IMPORTED_MODULE_0__/* .priceFilterValues */ .j_[slug];
    });
    return prices || [];
};
var getLocationFilter = function(queryParams) {
    return ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.location) || []).map(function(location) {
        var ref, ref1, ref2;
        return {
            gte: (ref = _filterData__WEBPACK_IMPORTED_MODULE_0__/* .locationFilterValues */ .qV[location]) === null || ref === void 0 ? void 0 : ref.gte,
            lte: (ref1 = _filterData__WEBPACK_IMPORTED_MODULE_0__/* .locationFilterValues */ .qV[location]) === null || ref1 === void 0 ? void 0 : ref1.lte,
            slug: location,
            name: (ref2 = _filterData__WEBPACK_IMPORTED_MODULE_0__/* .locationFilterValues */ .qV[location]) === null || ref2 === void 0 ? void 0 : ref2.name
        };
    });
};
var getDeliveryFilter = function(queryParams) {
    var ref, ref1;
    return {
        postCode: (queryParams === null || queryParams === void 0 ? void 0 : (ref = queryParams["post-code"]) === null || ref === void 0 ? void 0 : ref[0]) || "",
        date: (queryParams === null || queryParams === void 0 ? void 0 : (ref1 = queryParams.date) === null || ref1 === void 0 ? void 0 : ref1[0]) || ""
    };
};
/*
 * Change handlers
 */ var filtersChangeHandler = function(filters, attributeFilters, setAttributeFilters) {
    return function(name, value, singleValue) {
        if (attributeFilters && attributeFilters.hasOwnProperty(name)) {
            if (attributeFilters[name].includes(value)) {
                if (filters.attributes[name].length === 1) {
                    var att = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters);
                    delete att[name];
                    setAttributeFilters((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, att));
                } else {
                    setAttributeFilters((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, name, attributeFilters[name].filter(function(item) {
                        return item !== value;
                    }))));
                }
            } else if (singleValue && filters.attributes[name].length >= 1) {
                setAttributeFilters((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, name, [
                    value
                ])));
            } else {
                setAttributeFilters((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, name, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(attributeFilters[name]).concat([
                    value
                ]))));
            }
        } else {
            setAttributeFilters((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, attributeFilters), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, name, [
                value
            ])));
        }
    };
};
var getActiveFilterAttributes = function(filterAttributes, attributes) {
    var getAttribute = function(attributeSlug, valueSlug) {
        var ref, ref1, ref2;
        var valueName = (ref2 = (ref = attributes === null || attributes === void 0 ? void 0 : attributes.find(function(param) {
            var slug = param.slug;
            return attributeSlug === slug;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.values) === null || ref1 === void 0 ? void 0 : ref1.find(function(param) {
            var slug = param.slug;
            return valueSlug === slug;
        })) === null || ref2 === void 0 ? void 0 : ref2.name;
        return valueName ? {
            attributeSlug: attributeSlug,
            valueName: valueName,
            valueSlug: valueSlug
        } : undefined;
    };
    return filterAttributes && Object.keys(filterAttributes).reduce(function(acc, key) {
        return acc.concat(filterAttributes[key].map(function(valueSlug) {
            return getAttribute(key, valueSlug);
        }));
    }, []).filter(Boolean);
};


/***/ })

}]);